module.exports = __webpack_public_path__ + "media/src/assets/Images/HeroBackground-494e2bfec38a5e912ac8a6ddba0e15fe.svg";